import WebApiService from "@/services/webapi.service.js";
import StatoContratto from "@/models/statoContratto.model.js";

const state = {
    statiContratto: []
}

const getters = {

    getStatiContratto: (state) => {
        return state.statiContratto;
    },
    getDescrizioneStatoContratto: (state) => (codice) => {

        if(!state.statiContratto){
            return "";
        }    

        let stato = state.statiContratto.find(item => { return item.Codice === codice });

        if(!stato){
            return "";
        }

        return stato.Descrizione;    

    }
}

const mutations = {

    setstatiContratto: (state, statiContratto) => {
        state.statiContratto = statiContratto;      
    }
}

const actions = {

    getStatiContratto: ({commit}, data) => {                                                                                                              
        return WebApiService.get('Contratti/GetStatiContratto', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setstatiContratto", data.Data.map(
                        o => { return Object.assign(new StatoContratto(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}